export enum StackSelectionResult {
    SELECTED = 'selected',
    SKIP_DISPATCH = 'skip_dispatch',
    CANCELLED = 'cancelled',
}

export interface StackSelectionResponse {
    result: StackSelectionResult;
    selectedStack?: string;
}
